import { Component, OnInit, Input } from "@angular/core";
import { FiltersComponentInterface } from "../filters.enum";

@Component({
  selector: "lib-filters-component",
  templateUrl: "./filters-component.component.html",
  styleUrls: ["./filters-component.component.scss"]
})
export class FiltersComponentComponent implements OnInit {
  /**
   *
   * This is the type that must be passed to component for generate filters
   * @type {FiltersComponentInterface}
   * @memberof FiltersComponentComponent
   */
  @Input() filters_options: FiltersComponentInterface;
  @Input() inner: boolean = false;
  constructor() { }

  ngOnInit() { }
}
